import { useMutation } from "react-query"
import api from "../client"
import { queryClient, queryKeys } from "../query"
import { UpdateUserTermsPayload } from "../types/user"

const patchData = async (uuid: string | undefined, payload: UpdateUserTermsPayload) => {
    const { data } = await api.patch(
        `/users/${uuid}`,
        payload
    )

    queryClient.invalidateQueries(queryKeys.USER(uuid))

    return data
}

export const useUpdateUserTerms = (uuid: string | undefined) => {
    return useMutation((payload: UpdateUserTermsPayload) => {
        return patchData(uuid, payload)
    })
}
